// auto-generated by Typewriter template _enums.tst from PortCall.Services\PortCallUsers\PortCallUserService.cs
export enum PortCallUserRole { 
    Agent = 1,
    Requestor = 2,
    SchedulingAuthority = 4,
    AgentEditor = 8,
    InvitedEditor = 16,
    Watcher = 32,
    Any = 65535,
    None = 0
}

export const PortCallUserRoleDisplayName : { [val : number] : string } = { 
    1: 'Agent',
    2: 'Requestor',
    4: 'SchedulingAuthority',
    8: 'AgentEditor',
    16: 'InvitedEditor',
    32: 'Watcher',
    65535: 'Any',
    0: 'None'
}

export const PortCallUserRoles : { Id : PortCallUserRole, Name : string }[] = [ 
    { Id: PortCallUserRole.Agent, Name: 'Agent' },
    { Id: PortCallUserRole.Requestor, Name: 'Requestor' },
    { Id: PortCallUserRole.SchedulingAuthority, Name: 'SchedulingAuthority' },
    { Id: PortCallUserRole.AgentEditor, Name: 'AgentEditor' },
    { Id: PortCallUserRole.InvitedEditor, Name: 'InvitedEditor' },
    { Id: PortCallUserRole.Watcher, Name: 'Watcher' },
    { Id: PortCallUserRole.Any, Name: 'Any' },
    { Id: PortCallUserRole.None, Name: 'None' }
]



// WEBPACK FOOTER //
// ./server/enums/PortCallUserRole.ts